var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMessageRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5c-2.21 0-4 1.79-4 4 0 .75.21 1.46.58 2.06.2.34.46.65.76.91.7.64 1.63 1.03 2.66 1.03 1.46 0 2.73-.78 3.42-1.94.37-.6.58-1.31.58-2.06 0-1.02-.39-1.96-1.03-2.67A3.944 3.944 0 0 0 5 13.5zm1.07 5.8c-.19 0-.38-.07-.53-.22l-.53-.53-.55.55c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.55-.55-.53-.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.53.53.5-.5c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.5.5.53.53c.29.29.29.76 0 1.06-.15.15-.34.22-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.43C4.9 2.43 3 4.33 3 7.18v4.46c0 .35.36.6.7.51.42-.1.85-.15 1.3-.15 2.86 0 5.22 2.32 5.48 5.13.02.28.25.5.52.5h.55l4.23 2.82c.62.42 1.47-.04 1.47-.8v-2.02c1.42 0 2.61-.48 3.44-1.3.83-.84 1.31-2.03 1.31-3.45v-5.7c0-2.85-1.9-4.75-4.75-4.75h-9.5zm1.42 8.38a.715.715 0 0 1 0-1.43h6.66a.715.715 0 0 1 0 1.43H9.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMessageRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-message-remove.aa1e1a58059d1b3fee18de4e02eafe79.svg";
export { ForwardRef as ReactComponent };